var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.textButton && _vm.textButton !== '')?[_c('v-btn',{class:_vm.classButton,attrs:{"color":_vm.classColor ? _vm.classColor : 'primary',"small":!_vm.normalButton,"disabled":_vm.disabled,"dark":!_vm.disabled,"href":_vm.href,"target":"_blank","block":_vm.blockButton,"loading":_vm.loading,"dense":""},on:{"click":function($event){return _vm.handleClick()}}},[(_vm.iconBut)?_c('v-icon',{attrs:{"left":""}},[_vm._v("\n        "+_vm._s(_vm.iconBut)+"\n      ")]):_vm._e(),_vm._v("\n      "+_vm._s(_vm.textButton)+"\n    ")],1)]:[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"color":_vm.addButton
              ? 'primary'
              : _vm.editButton
              ? 'amber lighten-1'
              : _vm.reprogramarButton
              ? 'green'
              : _vm.verButton
              ? 'success'
              : _vm.playButton
              ? 'red'
              : _vm.cameraButton
              ? 'primary'
              : _vm.bookButton
              ? 'primary'
              : _vm.downloadButton
              ? 'primary'
              : _vm.uploadButton
              ? 'primary'
              : _vm.listButton
              ? 'black'
              : _vm.deleteButton
              ? 'red'
              : _vm.configButton
              ? 'grey darken-1'
              : _vm.classColor,"icon":"","disabled":_vm.disabled,"x-small":"","href":_vm.href,"loading":_vm.loading,"dense":"","target":"_blank","dark":!_vm.disabled},on:{"click":function($event){return _vm.handleClick()}}},on),[_c('v-icon',[_vm._v("\n            "+_vm._s(_vm.addButton
                ? "fas fa-plus"
                : _vm.editButton
                ? "fa fa-pencil-alt"
                : _vm.reprogramarButton
                ? "fas fa-calendar-alt"
                : _vm.verButton
                ? "fa-eye"
                : _vm.playButton
                ? "fas fa-play-circle"
                : _vm.cameraButton
                ? "fas fa-video"
                : _vm.bookButton
                ? "fas fa-book"
                : _vm.downloadButton
                ? "fas fa-file-download"
                : _vm.uploadButton
                ? "fas fa-file-upload"
                : _vm.listButton
                ? "fa-clipboard-list"
                : _vm.deleteButton
                ? "fas fa-trash-alt"
                : _vm.configButton
                ? "fas fa-cogs"
                : _vm.iconBut)+"\n          ")])],1)]}}])},[_c('span',[_vm._v("\n        "+_vm._s(_vm.tooltipText)+"\n      ")])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }